import React from 'react';
import { StyledOffer } from './Offer.style';
import Skeleton from 'react-loading-skeleton';

const OfferSkeleton = () => {

  return (
    <StyledOffer className='make-offer'>
      <div className='make-offer__inner'>
        <header className='make-offer__header'>
          <h5 className='make-offer__header-title'>
            <Skeleton count={1} height={28} borderRadius={5} width={140} className='make-offer__main-btn' />
          </h5>
        </header>
        <div className='make-offer__main'>
          <h6 className='make-offer__main-title'>
            <Skeleton count={1} height={20} borderRadius={5} width={190} className='make-offer__main-btn' />
          </h6>
          <p className='make-offer__main-price'>
            <Skeleton count={1} height={24} borderRadius={5} width={80} className='make-offer__main-btn' />
          </p>
          <Skeleton count={1} height={40} borderRadius={5} width={300} className='make-offer__main-btn' />
        </div>
      </div>
    </StyledOffer>
  )
}

export default OfferSkeleton;
